import type { ComponentProps } from 'react'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from './CommandModalButton'
import { CommandModalDataFallbackForm } from './CommandModalDataFallbackForm'
import type { ActionButtonProps } from './types'

export const LifeCommandModalButtonFallback = (props: ActionButtonProps) => {
  const { tenantId, legalEntityId } = useHook(
    // This component can be used for both person and company commands
    'routing.general.useLegalEntityParams',
  )()
  const commandData = props.eventVersionWithCommand?.commandVersion?.commandData

  const actions = useHook('mutators.life.useLifeCommandFallbackActions')({
    ownerId: legalEntityId,
    tenantId,
    ...props,
  })

  const submit = useVariantAction({
    ...props,
    actions,
  })

  const actionId = `life.${commandData?._type}`

  return props.commandActionVariant === 'create' ? null : (
    <CommandModalButton
      actionId={
        actionId as ComponentProps<typeof CommandModalButton>['actionId']
      }
      // Translations here will be looked at in a later PR: APG2223-3986
      title={commandData?._type ?? ''}
      commandDataForm={CommandModalDataFallbackForm}
      submit={submit}
      {...props}
    />
  )
}
